// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"21c02382","283":"a27d05ab","435":"9617ec22","590":"a2a93002","744":"80a79ef8","812":"c73f1305","872":"75eb45fd","970":"cc3cfaa9"}[chunkId] + ".chunk.js";
};